import { render } from "./IPOcalendar.vue?vue&type=template&id=06c00e47&scoped=true"
import script from "./IPOcalendar.vue?vue&type=script&lang=js"
export * from "./IPOcalendar.vue?vue&type=script&lang=js"

import "./IPOcalendar.vue?vue&type=style&index=0&id=06c00e47&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c00e47"]])

export default __exports__